import React, { useState } from "react";
import styled from "styled-components";
import { BASIC_WHITE } from "../../../constants/colors";
import { CouponExternal, CouponType } from "../../../ducks/coupon/types";
import { Button } from "../../atoms/Button";
import { AppCouponMenuItem } from "../../molecules/coupon/AppCouponMenuItem";
import { PopupModalContainer, fadein } from "./PopupModal.styles";

type Props = {
  coupon: CouponExternal | null;
  isOpen: boolean;
  handleUse: (coupon: CouponExternal, quantity: number) => void;
  handleClose: () => void;
};

export const AppCouponMenuModal: React.FC<Props> = ({
  coupon,
  isOpen,
  handleUse,
  handleClose,
}) => {
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  if (!isOpen || !coupon) return null;

  return (
    <PopupModalContainer $isOpen={isOpen}>
      <ModalContainer $isOpen={isOpen}>
        <ModalHeader>希望の商品を選択してください</ModalHeader>

        <ModalContent>
          <AppCouponMenuItem
            menu={coupon.menu!}
            quantity={selectedQuantity}
            disabled={coupon.kind === CouponType.App}
            onChange={(qty) => setSelectedQuantity(qty)}
          />
        </ModalContent>

        <ModalFooter>
          <Button
            disabled={selectedQuantity === 0}
            btnStyle="primary"
            text="このクーポンを利用"
            onClick={() => handleUse(coupon, selectedQuantity)}
          />
          <Button btnStyle="secondary" text="閉じる" onClick={handleClose} />
        </ModalFooter>
      </ModalContainer>
    </PopupModalContainer>
  );
};

const ModalContainer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  animation: ${fadein} 0.5s forwards;
`;

const ModalHeader = styled.div`
  padding: 25px 0;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
  padding: 0px 15px;
  text-align: center;
`;

const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 15px;
  background-color: ${BASIC_WHITE};
`;
